import { render } from "./AddEditDocumentModalDialog.vue?vue&type=template&id=a82e896c&scoped=true&ts=true&lang=pug"
import script from "./AddEditDocumentModalDialog.vue?vue&type=script&lang=ts"
export * from "./AddEditDocumentModalDialog.vue?vue&type=script&lang=ts"

import "./AddEditDocumentModalDialog.vue?vue&type=style&index=0&id=a82e896c&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82e896c"]])

export default __exports__